import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p434970891593392128',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
